import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class AppLoaderService {
  public loading$ = new BehaviorSubject<boolean>(false);
  public loadingChanges = this.loading$.asObservable();
  public showMask = true;

  public show() {
    this.loading$.next(true);
  }

  public showSpinnerWithoutOverlay() {
    this.showMask = false;
    this.show();
  }

  public hide() {
    this.loading$.next(false);
  }
}
